import { Alert, Button, FormSection, Text } from '@ksyos/design-system';
import { translateKey } from '../../translate';
import { FormParagraphFormGroup } from '../fields/FormParagraphField';
import { Modal } from './modals/Modal';

interface IStopRightsModalProps {
    alertMessages: string[];
    bodyText: string;
    confirmText?: string;
    endDate: string;
    onClose: () => void;
    onStopRight: () => Promise<void>;
    title: string;
}

export function StopRightsModal(props: IStopRightsModalProps) {
    return (
        <Modal
            actionButtons={[
                <Button
                    onClick={() => props.onClose()}
                    variant="outline"
                >
                    {translateKey('common.cancel')}
                </Button>,
                <Button onClick={props.onStopRight}>{props.confirmText || translateKey('profile.stop')}</Button>,
            ]}
            isOpen={true}
            onClose={() => props.onClose()}
            size="medium"
            title={props.title}
        >
            {props.alertMessages.map((alertMessage) => (
                <Alert
                    appearance="warning"
                    key={alertMessage}
                >
                    {alertMessage}
                </Alert>
            ))}
            <Text mb={8}>{props.bodyText}</Text>
            <FormSection>
                <FormParagraphFormGroup label={translateKey('common.endDate')}>{props.endDate}</FormParagraphFormGroup>
            </FormSection>
        </Modal>
    );
}
